import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useLocation, useNavigate } from "react-router";
import { editcategorylist, editinterviewlist } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};

const EditCategory = () => {
  const [load, setload] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [preview, setPreview] = useState();
  const [image, setImage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;
  console.log(location);

  useEffect(() => {
    formik.setValues(
      {
        name: items.name,
      },
      false
    );
    setPreview(items.image);
    formik.validateForm();
  }, [items]);

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await editcategorylist(items.id, values.name, image);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleupload = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit Category</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Category Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div>
            <p className="Auth_label">Category Image</p>

            <label htmlFor="catimg">
              <img
                src={preview}
                alt="editprofile_image"
                className="images_cate"
              />
            </label>
            <input
              onChange={handleupload}
              id="catimg"
              name="img"
              type="file"
              className="Auth_input"
              style={{ display: "none" }}
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div />

          <button className="term_button" type="Submit">
            Save
          </button>
        </form>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={2000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};
export default EditCategory;
